module.exports = __webpack_public_path__ + "static/img/butterfly.a02d561.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/butterfly.png
// module id = Woia
// module chunks = 1